/* eslint-disable jsx-a11y/media-has-caption */
import * as React from "react";
import { useAppSelector } from "../../../../store/hooks";
import store from "../../../../store/store";

interface Props {
  audioEffectToBePlayed: string;
}

const AudioPlayerNonInteractiveEffect: React.FC<Props> = ({
  audioEffectToBePlayed,
}) => {
  const isMute = useAppSelector((state) => state.audio.isMute);

  return (
    <>
      {store.getState().audio.areAudioEffectsEnabled && (
        <audio autoPlay muted={isMute}>
          <source src={audioEffectToBePlayed} />
        </audio>
      )}
    </>
  );
};

export default AudioPlayerNonInteractiveEffect;
